
<!DOCTYPE html>

<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet">
  <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/js/bootstrap.bundle.min.js"></script>
  <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.0.8/css/all.css">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
  <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css">
</head>







<div class="card" *ngIf="ShowCard===2">
  <div class="card-body">
<br>
    <div class="row">
      <p style="color: #6ab187;"><strong>EMPLOYEE SCREENING</strong></p>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/users.png"><a style="text-decoration: none;color:black" routerLink="/whitecollar"> <strong class="white">&nbsp; White-collar verification</strong></a></div>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/mechanic.png"><a style="text-decoration: none;color: black;"  routerLink="/bluecollar"><strong class="white"> Blue-collar verification</strong></a></div>
      <br><br>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/online-business.png"><a style="text-decoration: none;color: black;" routerLink="/gigworker"> &nbsp;<strong class="white"> Gig Worker verification</strong></a></div>
    </div>
    <br>
    
    <div class="row">
      
      <p style="color: #6ab187;"><strong>RISK & COMPLIANCE</strong></p>
      <div class="col-3"><img style="width: 30px;height: auto;" src="assets/risktopicon.png"><a style="text-decoration: none;color: black;" routerLink="/riskmanage"><strong class="white"> Risk Management</strong></a></div>
      <div class="col-3"><img style="width: 35px;height: auto;" src="assets/onboarding.png"><a style="text-decoration: none;color: black;" routerLink="/vendor"><strong class="white" > Vendor Onboarding</strong></a></div>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/distributortopicon.png"><a style="text-decoration: none;color: black;" routerLink="/distribute"><strong class="white"> Distributor onboarding</strong></a></div>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/duediligence.jpg"><a style="text-decoration: none;color: black;" routerLink="/duediligence"><strong class="white"> Due Diligence</strong> </a></div>
    </div>
    <br>
  
    <!--  -->
    <div class="row">
      
      <p style="color: #6ab187;"><strong> FINANCIAL INTELLIGENCE</strong></p>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/kycsolution.png"><a style="text-decoration: none;color: black;" routerLink="/kycsolution"><strong class="white"> KYC solutions</strong> </a></div>
    </div>
    <br>
  
  </div>
</div>


<div class="card" *ngIf="ShowCard===1">
  <div class="card-body">
<br>
<p style="color: #6ab187;font-weight: 600;"><strong>PRODUCT</strong></p>

    <div class="row">
      <div class="col"><a style="text-decoration: none;color: black;cursor: pointer;" (click)="ShowCard=3"><strong class="white"><img style="width: 4%;height: 100%;" src="assets/docverify.png"> Document Verification</strong> </a></div>
      <div class="col"><a style="text-decoration: none;color: black;cursor: pointer;" routerLink="/service"><strong class="white"><img style="width: 5%;height: 110%;" src="assets/docsignin.png"> Document SignIn</strong> </a></div>
  
    </div>
    <br>

    <div class="row">
       </div>
    <br>
    
  </div>
</div>


<!--  -->

<div class="card" *ngIf="ShowCard===3">
  <div class="card-body">
    <br>
<div class="row">
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/aadhartopicon.png"><a style="text-decoration: none;color: black;" routerLink="/aadhaar"> <strong class="white"> Aadhaar verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/pantopicon.png"><a style="text-decoration: none;color: black;"  routerLink="/pan"><strong class="white"> Pan verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/gsttopicon.jpg"><a style="text-decoration: none;color: black;" routerLink="/gst"><strong class="white"> Gst verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/drivinglicensetop.jpg"><a style="text-decoration: none;color: black;" routerLink="/driving"><strong class="white"> Driving verification</strong></a></div>
</div><br><br>

<div class="row">
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/passporttopicon.png"><a style="text-decoration: none;color: black;" routerLink="/passport"><strong class="white"> Passport verification</strong> </a></div>
  <div class="col"><img style="width: 58px;height: 44px;" src="assets/rcverify.png"><a style="text-decoration: none;color: black;" routerLink="/rcverify"><strong class="white"> RC verification</strong></a></div>
  <div class="col"><img style="width: 45px;height: 44px;" src="assets/msmeverify.png"><a style="text-decoration: none;color: black;" routerLink="/msmeverify"><strong class="white"> MSME verification</strong> </a></div>
  <div class="col"><img style="width: 45px;height: 44px;" src="assets/verification.png"><a style="text-decoration: none;color: black;" routerLink="/dinverify"><strong class="white"> DIN verification</strong></a></div>
</div>

<br><br>
<div class="row">
  <div class="col-3"><img style="width: 35px;height: 44px;border-radius: 20px;" src="assets/cinicon.png"><a style="text-decoration: none;color: black;" routerLink="/cinverify"><strong  class="white"> CIN verification</strong></a></div>
</div>
</div>
</div>


<br><br>


<div class="row"  data-aos="zoom-in" data-aos-delay="300">
    

    <div class="col-md-6 text-center">
        <img style="width:70%;margin-top:10%;border-radius:40px;box-shadow: 50px 20px #76b891;" src="assets/gigeco.png">
    </div>
    <div style="padding-top: 10%;" class="col-md-6">
      <h1>
          <span class="topic">Gig Worker Verification Made Easy </span>
        </h1>
      <h5 style="padding-left: 10%;">&nbsp;&nbsp;&nbsp;Streamline your gig worker onboarding process and hire the best talent for your business.</h5>
  </div>
</div>
<br><br>
<br>


<br><br>
<div class="row" data-aos="zoom-in" data-aos-delay="300">
    <div class="col">
        <h1 style="color: #6ab187;text-align: center;">Modernize the gig worker Journeys </h1>
        <br>
        <p style="text-align: center;">Comprehensive, advanced and tech-first approach to transform the gig worker verification</p>


           <br><br>
<div  class="row"  data-aos="fade-up" data-aos-delay="300">

    <div style="background-color: #eff8ff;"  class="col-md-4">
        <br>
        <img style="width: 80px;height: 65px;background-color: #eff8ff;" src="assets/fastverify.jpg">
       <br><br><br>
        <h5>Verify Faster </h5>
        <p style="align-items: center;">No more delays in gig worker verification. Authenticate your gig workers in record time with our instant verification APIs that integrate into your application.</p>
    </div>
  
    <div style="background-color: #c9d9e6;" class="col-md-4">
          <br>
          <img style="width: 70px;height: 60px;" src="assets/theft.png">
         <br><br><br>
          <h5>Eliminate Identity Theft</h5>
          <p style="align-items: center;">Identify impersonation or other identity theft risk with extensive database and real-time checks to mitigate any reputation risks.</p>
      </div>
     
      <div  style="background-color: #eff8ff;" class="col-md-4">
     
        <br>
        <img style="width: 70px;height: 70px;" src="assets/streamline.png">
       <br><br><br>
        <h5>Streamlined Verification </h5>
        <p style="align-items: center;">End-to-end automation of your gig-worker verification. From assisted documented collection to verification — onboard and verify your workforce faster.<p>
    </div>
  </div>
    </div>
</div> 


<!--  -->
<br><br><br><br><br>
<div class="row" data-aos="zoom-in" data-aos-delay="300">
    <div  class="col">
        <h2 style="color: #6ab187;text-align: center;">Screen Within Minutes - Process for Gig Worker Verification</h2>

        <br><br>
  <div  class="row p-4" data-aos="fade-up" data-aos-delay="300">

    <div   class="col-md-3">
        <br>
        <img style="width: 60px;height: 65px;" src="assets/gigcapture.png">
       <br><br><br>
        <h5>STEP 1</h5>
        <p style="align-items: center;">Gig Worker Captures the NID Image</p>
    </div>
  
    <div class="col-md-3">
          <br>
          <img style="width: 80px;height: 80px;" src="assets/ocrverify.png">
         <br><br>
          <h5>STEP 2</h5>
          <p style="align-items: center;">OCR extracts the information and validates it</p>
      </div>
     
      <div class="col-md-3">
     
        <br>
        <img style="width: 70px;height: 60px;" src="assets/geotagliveness.jpg">
       <br><br><br>
        <h5 >STEP 3</h5>
        <p style="align-items: center;">DAV with geotagging coordinates and candidate liveness detection <p>
    </div>

    <div class="col-md-3">
     
        <br>
        <img style="width: 60px;height: 60px;" src="assets/verifyicon.png">
       <br><br><br>
        <h5 >STEP 4</h5>
        <p style="align-items: center;">Worker e-signs to complete the process.<br>  In case of mismatch, they can be<br> re-submit documents<p>
    </div>
  
  </div>
    </div>
</div>


<!--  -->
<br><br>
<div class="row"  data-aos="zoom-in" data-aos-delay="300">
    <div class="col">
        <h3 style="color: #6ab187;text-align: center;">Facheck’s Gig Worker Screening </h3>
        <h2 style="text-align: center;">Trust in Your Gig Worker Hiring Decisions</h2><br>
        <p style="text-align: center;">Cutting-edge gig worker screening solution you need to simplify and optimize your hiring process like never before.</p>
    </div>
</div>
<br><br>

<div class="row p-2" data-aos="fade-up" data-aos-delay="300">
    <div class="col-md-6">
        <br>
        <img style="width: 42px;height: 39px" src="assets/fast.png">
        <span style="color: #6ab187;">Fast</span><br>
        <h3 style="text-align: start;color: #6ab187;">Say Goodbye to lengthy onboard Process</h3>
        <p >Don’t let the screening process be a bottleneck. Automate your worker onboarding process with our one-stop solution.  Enable workers to onboard themselves in minutes, while ensuring accuracy and complaince. </p>
    </div>

    <div class="col-md-6 text-align"> 
        <img style="width: 80%;height: 80%;margin-top: 20px;" src="assets/onboardlength.png">
    </div>
    </div>

<!--  -->


<div class="row p-2" data-aos="fade-up" data-aos-delay="300" >
 
    <div class="col-md-6 text-center">
        <img style="width: 80%;height: 100%;" src="assets/identityverification.png">
    </div>

    <div class="col-md-6">
        <img style="width: 42px;height: 45px;" src="assets/authentication.png">
        <span style="color: #6ab187;height: 20%;">Authentication</span>
        <h3 style="text-align: start;color: #6ab187;">Resolve 90% of Verifications in Real Time</h3>
        <p >Leverage the powerful combination of instant verifications API’s with the expansive field force to complete majority of your gig worker authentications in real time. </p>
    </div>
</div>


<!--  -->


<div class="row p-2" data-aos="fade-up" data-aos-delay="300">
    <div class="col-md-6">
        <br>
        <img style="width: 42px;height: 39px" src="assets/singleview.png">
        <span style="color: #6ab187;">Single View</span><br>
        <h3 style="text-align: start;color: #6ab187;">Consolidated View of your Gig Worker Operations</h3>
        <p >Have complete visibility of the status of each gig worker’s verification status. Know how many cases have been initiated or yet to be initiated, how many verifications are ongoing and the details of all the completed cases on a single screen.</p>
    </div>

    <div class="col-md-6  text-center">
        <img style="width: 80%;height: 80%;margin-top: 20px;" src="assets/consolidategig.png">
    </div>
    </div>



    
    <div class="row p-2" data-aos="fade-up" data-aos-delay="300">
     
        <div class="col-md-6 text-center">
            <img style="width: 80%;height: 100%;margin-left: 20px;" src="assets/identityverification.png">
        </div>
    
        <div class="col-md-6">
            <img style="width: 70px;height: 45px;" src="assets/integration.png">
            <span style="color: #6ab187;height: 20%;">Integrations</span>
            <h3 style="text-align: start;color: #6ab187;">Easily Integrate Checks in Your Onboarding Journeys</h3>
            <p >Onboard workers anytime, anywhere with our custom integrations. No need to break your onboarding journeys or deploy multiple systems and processes. We integrate with your existing systems and applications to prove a smooth and effective onboarding experience for the gig workers.</p>
        </div>
    </div>

<br><br><br><br><br>
    <div class="row" data-aos="zoom-in" data-aos-delay="300">
        <div class="col">
            <h3 style="text-align: center;color: #6ab187;">Gig Worker Verification Checks </h3>
            <p style="text-align: center;">Background Verification Checks to authenticate your Gig Workers</p>
        </div>
    
    </div>
    <br><br>
    
    <div class="row p-2 text-center" data-aos="fade-up" data-aos-delay="300" >
        <div class="col-md-3 mt-2">
            <div  class="card" style="height: 200px;" >
                <div class="card-body">
        
                    <img style="width: 34%;height:30%" src="assets/aadhaar.png">
    <br><br>
                  <h5 class="card-title">Aadhaar Verification</h5>
                </div>            
              </div>
        </div>
    
        <div class="col-md-3 mt-2">
          <div class="card" style="height: 200px;" >
              <div class="card-body">
                  <img style="width: 34%;height:30%" src="assets/panchecks.png">
               <br><br>
                <h5 class="card-title">Pan Card verification</h5>
              </div>            
            </div>
      </div>
    
      <div class="col-md-3 mt-2">
        <div class="card" style="height: 200px;" >
            <div  class="card-body">
    
                <img style="width: 30%;height:30%" src="assets/voterid.jpg">
                <br><br>
              <h5 class="card-title">Voter Id verification</h5>
            </div>            
          </div>
    </div>
    
    <div class="col-md-3 mt-2">
      <div class="card" style="height: 200px;" >
          <div class="card-body">
              <img style="width: 34%;height:30%"  src="assets/faceverify.jpg">
              <br><br>
            <h5 class="card-title">Face Match Verification</h5>
    
          </div>       
               
        </div>
    </div>


    <div class="col-md-3 mt-2">
        <div class="card" style="height: 200px;" >
            <div  class="card-body">
    
                <img style="width: 30%;height:30%" src="assets/employverify.jpg">
                <br><br>
              <h5 class="card-title">Employment verification</h5>
            </div>            
          </div>
    </div>
    <div class="col-md-3 mt-2">
      <div  class="card" style="height: 200px;" >
          <div class="card-body">
  
              <img style="width: 33%;height:30%" src="assets/drivinglic.png">
<br><br>
            <h5 class="card-title">Driving License check</h5>
          </div>            
        </div>
  </div>

  <div class="col-md-3 mt-2">
    <div class="card" style="height: 200px;" >
        <div class="card-body">
            <img style="width: 34%;height:30%" src="assets/vehiclerc.png">
         <br><br>
          <h5 class="card-title">Vehicle RC verification</h5>
        </div>            
      </div>
</div>

<div class="col-md-3 mt-2">
  <div class="card" style="height: 200px;" >
      <div  class="card-body">

          <img style="width: 30%;height:30%" src="assets/police.png">
          <br><br>
        <h5 class="card-title">Police verification</h5><br>
      </div>            
    </div>
</div>

<div class="col-md-3 mt-2">
<div class="card" style="height: 200px;" >
    <div class="card-body">
        <img style="width: 34%;height:30%"  src="assets/courtrecord.png">
        <br><br>
      <h5 class="card-title">India court Record</h5>

    </div>       
         
  </div>
</div>


<div class="col-md-3 mt-2">
  <div class="card" style="height: 200px;" >
      <div  class="card-body">

          <img style="width: 30%;height:30%" src="assets/address.jpg">
          <br><br>
        <h5 class="card-title">Address verification</h5>
      </div>            
    </div>
</div>


      </div>
      <br><br><br>
    
    
    



  
   



      <div class="row" data-aos="zoom-in" data-aos-delay="300"   >
        <div class="col">
       
          <!-- Footer -->
          <footer class="text-center text-lg-start text-white" style="background-color: #1c2331">
            <!-- Section: Social media -->
            <section class="d-flex justify-content-between p-4" style="background-color: #6ab187">
              <!-- Left -->
              <div class="me-5">
                <span>Get connected with us on social networks:</span>
              </div>
              <!-- Left -->
      
              <!-- Right -->
              <div>
      
                <a href="" class="text-white me-5">
                  <i class="fab fa-instagram"></i>
                </a>
      
      
              </div>
              <!-- Right -->
            </section>
            <!-- Section: Social media -->
      
      
            <section data-aos="zoom-in" data-aos-delay="300" class="p-4">
              <div class="text-center text-md-start mt-5">
      
                <div class="row">
      
                  <div class="col-md-4 ">
                    <!-- Content -->
      
                    <h6 style="margin-right: 74%;font-size:16px" class="text-uppercase fw-bold"><img
                        style="width: 27px;height: auto;border-radius: 40%;" src="assets/handlogo.png"> FACheck</h6>
      
                    <p style="text-align: justify;
        text-justify: inter-word">
                      Facheck is a very useful product in the Finance,Banking, and growing Industries in India. It checks &
                      authenticates the Person / Company document and reveals the result with the validity and truth of the
                      document. So, with the help of the Facheck - verification you can process the proper document and
                      avoid fraudulent disclosures. It help your organization to proceed further with Fact-Check of your
                      clients.
                    </p>
                  </div>
      
      
                  <div class="col-md-2">
                    <!-- Links -->
                    <h6 class="text-uppercase fw-bold" >Solutions</h6>
      
                    <p>
                      <a href="bluecollar"  class="text-white">Blue-collar
                        verify</a>
                    </p>
                    <p>
                      <a href="distribute"  class="text-white">Distributor
                        Onboard</a>
                    </p>
                    <p>
      
                      <a href="duediligence"  class="text-white">Due
                        Diligence</a>
                    </p>
                    <p>
      
                      <a href="gigworker"  class="text-white">Gig Worker
                        Verify</a>
      
                    </p>
                    <p>
      
                      <a href="kycsolution"  class="text-white">KYC
                        Solutions</a>
                    </p>
                    <p>
                      <a href="riskmanage"  class="text-white">Risk Manage</a>
                    </p>
                    <p>
      
                      <a href="vendor"  class="text-white">Vendor Onboard</a>
                    </p>
                    <p>
      
                      <a href="whitecollar"  class="text-white">White-collar
                        verify</a>
                    </p>
                  </div>
      
      
                  <div  class="col-md-2 text-align">
      
                    <h6 class="text-uppercase fw-bold" >Products</h6>
      
                    <p>
                      <a href="aadhaar"  class="text-white">Aadhaar verify</a>
                    </p>
                    <p>
                      <a href="cinverify"  class="text-white">CIN verify</a>
                    </p>
                    <p>
                      <a href="dinverify"  class="text-white">DIN verify</a>
                    </p>
                    <p>
                      <a href="driving"  class="text-white">Driving License</a>
                    </p>
                    <p>
                      <a href="gst"  class="text-white">GST verify</a>
                    </p>
                    <p>
                      <a  href="msmeverify" class="text-white">MSME verify</a>
                    </p>
                    <p>
                      <a href="pan"  class="text-white">PAN verify</a>
                    </p>
                    <p>
                      <a href="passport"  class="text-white">Passport verify</a>
                    </p>
                    <p>
                      <a href="rcverify"  class="text-white">RC verify</a>
                    </p>
      
                    <br><br><br>
                  </div>
      
      
      
      
                  <div  class="col-md-4 text-center">
      
                    <h6  class="text-uppercase fw-bold">Quick links</h6>
      
      
                    <a  href="privacypolicy">Privacy Policy</a>
                    <br><br>
                    <a  href="termscondition">Terms & Condition</a>
                    <br><br>
      
                    <a  href="refundpolicy">Refund Policy</a>
                    <br><br>
                    <!-- Links -->
                    <h6 class="text-uppercase fw-bold">Contact</h6>
      
      
                    <p >support@facheck.in &nbsp;<i
                        class="fas fa-envelope mr"></i> </p>
      
                    <p  class=" text-center ">Registered Head Office <i class="fas fa-home"></i>
                      <br>New 9, Old # 11, Ground Floor,
                      Palayakaran Street, Kalaimagal Nagar, Ekkaduthangal, Chennai
                    </p>
      
                  </div>
      
      
                
      
      
                </div>
                <!-- Grid row -->
      
      
              </div>
            </section>
            <br>
            <div class="text-center p-3" style="background-color: rgba(0, 0, 0, 0.2)">
              Copyright© 2023. Powered by
              <a class="text-white" href="#">facheck.com
                | All Rights Reserved </a>
            </div>
      
          </footer>
          <!-- Footer -->
      
        </div>
      </div>
      
      